module.exports = __webpack_public_path__ + "img/ios.4721cebb.png";